module.exports = __webpack_public_path__ + "static/media/Mapa-Pará.1537171f.svg";